<template>
    <div class="edit-table">
        <el-radio-group v-model="tierType" @change="handleTierTypeChange" :disabled="disabled"
            style="margin-bottom: 20px;">
            <el-radio :label="0">区间阶梯</el-radio>
            <el-radio :label="1">增量阶梯</el-radio>
        </el-radio-group>
        <vxe-toolbar v-if="!disabled">
            <template v-slot:buttons>
                <vxe-button @click="addTable()">添加行</vxe-button>
            </template>
        </vxe-toolbar>
        <vxe-table :data="qjList" v-show="tierType === 0">
            <vxe-table-column min-width="100" field="tableNumMin" title="宴席瓶数下限">
                <template #default="{ row }">
                    <el-input-number v-model="row.tableNumMin" :disabled="disabled" :controls="false" :precision="0"
                        placeholder="宴席瓶数下限"></el-input-number>
                </template>
            </vxe-table-column>
            <vxe-table-column min-width="100" field="tableNumMax" title="宴席瓶数上限">
                <template #default="{ row }">
                    <el-input-number v-model="row.tableNumMax" :disabled="disabled" :controls="false" :precision="0"
                        placeholder="宴席瓶数上限"></el-input-number>
                </template>
            </vxe-table-column>
            <vxe-table-column min-width="100" field="awardLat" title="奖励纬度">
                <template #default="{ row, rowIndex }">
                    <el-select v-model="row.awardLat" @change="banquetAwardLatTypeChange($event, rowIndex)"
                        placeholder="请选择奖励纬度" :disabled="rowIndex !== 0 || disabled">
                        <el-option v-for="item in banquetAwardLatTypeList" :key="item.dictCode" :label="item.dictValue"
                            :value="item.dictCode">
                        </el-option>
                    </el-select>
                </template>
            </vxe-table-column>
            <vxe-table-column min-width="100" field="rewardType" title="奖励类型">
                <template #default="{ row, rowIndex }">
                    <el-select v-model="row.rewardType" @change="banquetAwardTypeChange($event, rowIndex)"
                        placeholder="请选择奖励类型" :disabled="rowIndex !== 0 || disabled">
                        <el-option v-for="item in banquetAwardTypeList" :key="item.dictCode" :label="item.dictValue"
                            :value="item.dictCode">
                        </el-option>
                    </el-select>
                </template>
            </vxe-table-column>
            <vxe-table-column min-width="100" field="cashType" title="兑付方式">
                <template #default="{ row, rowIndex }">
                    <el-select v-model="row.cashType" @change="banquetCashTypeChange($event, rowIndex)"
                        placeholder="请选择兑付方式" :disabled="rowIndex !== 0 || disabled">
                        <el-option
                            v-for="item in (row.rewardType === 'fee' || row.rewardType === 'cash') ? banquetCashTypeList : banquetCashTypeList_1"
                            :key="item.dictCode" :label="item.dictValue" :value="item.dictCode">
                        </el-option>
                    </el-select>
                </template>
            </vxe-table-column>
            <vxe-table-column min-width="100" field="productName" title="奖励产品">
                <template #default="{ row, rowIndex }">
                    <el-input v-model="row.productName" disabled placeholder="奖励产品"
                        v-if="row.rewardType === 'fee' || row.rewardType === 'cash'">
                        <span>{{ row.productName }}</span>
                    </el-input>
                    <el-input v-model="row.productName" :disabled="disabled" readonly placeholder="奖励产品"
                        @click.native="productNameClick(rowIndex)" v-else>
                        <span>{{ row.productName }}</span>
                    </el-input>
                </template>
            </vxe-table-column>
            <vxe-table-column min-width="100" field="rewardNum" title="瓶数">
                <template #default="{ row }">
                    <el-input v-model="row.rewardNum" disabled placeholder="瓶数"
                        v-if="row.rewardType == 'fee' || row.rewardType == 'cash'">
                    </el-input>
                    <el-input v-model="row.rewardNum" :disabled="disabled" placeholder="瓶数" v-else>
                    </el-input>
                </template>
            </vxe-table-column>
            <vxe-table-column min-width="100" field="rewardAmount" title="每瓶奖励费用">
                <template #default="{ row }">
                    <el-input-number v-if="row.rewardType === 'fee' || row.rewardType === 'cash'"
                        v-model="row.rewardAmount" :disabled="disabled" :controls="false" :precision="2"
                        placeholder="每瓶奖励费用"></el-input-number>
                    <el-input-number v-else v-model="row.rewardAmount" disabled :controls="false" :precision="2"
                        placeholder="每瓶奖励费用"></el-input-number>
                </template>
            </vxe-table-column>
            <vxe-column title="操作" width="80" v-if="!disabled">
                <template #default="{ row, rowIndex }">
                    <template>
                        <span @click="deletRow(row, rowIndex)" style="color: red; cursor: pointer">删除</span>
                    </template>
                </template>
            </vxe-column>
        </vxe-table>
        <vxe-table :data="dzList" v-show="tierType === 1">
            <vxe-table-column min-width="100" field="startNum" title="起始桌数">
                <template #default="{ row }">
                    <el-input-number v-model="row.startNum" :disabled="disabled" :controls="false" :precision="0"
                        placeholder="起始桌数"></el-input-number>
                </template>
            </vxe-table-column>
            <vxe-table-column min-width="100" field="incrementNum" title="递增桌数">
                <template #default="{ row }">
                    <el-input-number v-model="row.incrementNum" :disabled="disabled" :controls="false" :precision="0"
                        placeholder="递增桌数"></el-input-number>
                </template>
            </vxe-table-column>
            <vxe-table-column min-width="100" field="awardLat" title="奖励纬度">
                <template #default="{ row, rowIndex }">
                    <el-select v-model="row.awardLat" @change="banquetAwardLatTypeChange($event, rowIndex)"
                        placeholder="请选择奖励纬度" :disabled="rowIndex !== 0 || disabled">
                        <el-option v-for="item in banquetAwardLatTypeList" :key="item.dictCode" :label="item.dictValue"
                            :value="item.dictCode">
                        </el-option>
                    </el-select>
                </template>
            </vxe-table-column>
            <vxe-table-column min-width="100" field="rewardType" title="奖励类型">
                <template #default="{ row, rowIndex }">
                    <el-select v-model="row.rewardType" @change="banquetAwardTypeChange($event, rowIndex)"
                        placeholder="请选择奖励类型" :disabled="rowIndex !== 0 || disabled">
                        <el-option v-for="item in banquetAwardTypeList" :key="item.dictCode" :label="item.dictValue"
                            :value="item.dictCode">
                        </el-option>
                    </el-select>
                </template>
            </vxe-table-column>
            <vxe-table-column min-width="100" field="cashType" title="兑付方式">
                <template #default="{ row, rowIndex }">
                    <el-select v-model="row.cashType" @change="banquetCashTypeChange($event, rowIndex)"
                        placeholder="请选择兑付方式" :disabled="rowIndex !== 0 || disabled">
                        <el-option
                            v-for="item in (row.rewardType === 'fee' || row.rewardType === 'cash') ? banquetCashTypeList : banquetCashTypeList_1"
                            :key="item.dictCode" :label="item.dictValue" :value="item.dictCode">
                        </el-option>
                    </el-select>
                </template>
            </vxe-table-column>
            <vxe-table-column min-width="100" field="productName" title="奖励产品">
                <template #default="{ row, rowIndex }">
                    <el-input v-model="row.productName" disabled placeholder="奖励产品"
                        v-if="row.rewardType === 'fee' || row.rewardType === 'cash'">
                        <span>{{ row.productName }}</span>
                    </el-input>
                    <el-input v-model="row.productName" :disabled='disabled' readonly placeholder="奖励产品"
                        @click.native="productNameClick(rowIndex)" v-else>
                        <span>{{row.productName }}</span>
                    </el-input>
                </template>
            </vxe-table-column>
            <vxe-table-column min-width="100" field="levelBottle" title="每级递增瓶数">
                <template #default="{ row }">
                    <el-input v-model="row.levelBottle" disabled placeholder="每级递增瓶数"
                        v-if="row.rewardType == 'fee' || row.rewardType == 'cash'">
                    </el-input>
                    <el-input v-model="row.levelBottle" :disabled="disabled" placeholder="每级递增瓶数" v-else>
                    </el-input>
                </template>
            </vxe-table-column>
            <vxe-table-column min-width="100" field="levelAmount" title="每级递增费用">
                <template #default="{ row }">
                    <el-input-number
                        v-model="row.levelAmount" :disabled="disabled" :controls="false" :precision="2"
                        placeholder="每级递增费用"></el-input-number>

                </template>
            </vxe-table-column>
            <vxe-table-column min-width="100" field="roundingCoefficient" title="取整系数">
                <template #default="{ row }">
                    <el-input-number :min="0" :max="1" v-model="row.roundingCoefficient" :disabled="disabled" :controls="false"
                         placeholder="取整系数"></el-input-number>
                </template>
            </vxe-table-column>
            <vxe-column title="操作" width="80" v-if="!disabled">
                <template #default="{ row, rowIndex }">
                    <template>
                        <span @click="deletRow(row, rowIndex)" style="color: red; cursor: pointer">删除</span>
                    </template>
                </template>
            </vxe-column>

        </vxe-table>
        <SelectConfig ref="selectConfig" @onGetSelect="onGetSelect" />
    </div>

</template>

<script>
import request from '@/found/utils/request';
import SelectConfig from '@/found/components/select_org_cus_ter/select_config.vue';
import { e } from 'mathjs';

export default {
  name: 'scoreRatio',
  components: {
    SelectConfig,
  },
  props: {
    value: [Array, Object],
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  watch: {
    value: {
      handler(val) {
        console.log(val);
        if (val) {
          this.tierType = val.tierType || 0;
          this.qjList = val.qjList || [];
          this.dzList = val.dzList || [];
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      qjList: [], // 区间列表
      dzList: [], // 区间列表
      banquetCashTypeList: [], // 兑付方式 费用
      banquetCashTypeList_1: [], // 兑付方式 实物
      banquetAwardTypeList: [], // 奖励类型
      banquetAwardLatTypeList: [], // 奖励纬度
      rIdex: 0,
      tierType: 0,
    };
  },
  async created() {
    await this.getDictSelect();
  },
  mounted() { },
  methods: {
    handleTierTypeChange(val) {
      console.log(val);
      if (val === 1) {
        this.qjList = [];
      } else {
        this.dzList = [];
      }
      this.tierType = val;
      this.toFather();
    },
    // 获取数据字典
    getDictSelect() {
      request.post('/mdm/mdmdictdata/batchDictSelect', ['banquet_award_lat_type', 'banquet_award_type', 'banquet_cash_type']).then((res) => {
        if (res.success) {
          this.banquetCashTypeList = res.result.banquet_cash_type.filter((item) => item.dictCode === 'red_package' || item.dictCode === 'cash');
          this.banquetCashTypeList_1 = res.result.banquet_cash_type.filter((item) => item.dictCode === 'goods' || item.dictCode === 'thawedCash');
          this.banquetAwardTypeList = res.result.banquet_award_type.filter((item) => item.dictCode === 'fee' || item.dictCode === 'product');
          this.banquetAwardLatTypeList = res.result.banquet_award_lat_type;
        }
      });
    },
    // 删除行
    deletRow(row, rowIndex) {
      console.log(this.qjList);
      this.$confirm('您确定要删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        if (this.tierType === 1) {
          if (rowIndex === 0) {
            this.dzList = [];
          } else {
            this.dzList.splice(rowIndex, 1);
          }
        } else if (rowIndex === 0) {
          this.qjList = [];
        } else {
          this.qjList.splice(rowIndex, 1);
        }
        this.toFather();
      });
    },
    toFather() {
      this.$emit('input', { tierType: this.tierType, qjList: this.qjList, dzList: this.dzList });
      this.$emit('change', { tierType: this.tierType, qjList: this.qjList, dzList: this.dzList });
    },
    // 新增预算信息
    addTable() {
      if (this.tierType === 1) {
        if (this.dzList.length === 1) {
          if (!this.dzList[0].awardLat) {
            this.$message.warning('请先选择奖励纬度');
            return;
          }
          if (!this.dzList[0].rewardType) {
            this.$message.warning('请先选择奖励类型');
            return;
          }
          if (!this.dzList[0].cashType) {
            this.$message.warning('请先选择兑付方式');
            return;
          }
        }
        this.dzList.push({
          startNum: 0,
          incrementNum: 0,
          awardLat: this.dzList.length >= 1 ? this.dzList[0].awardLat : null,
          awardLatName: this.dzList.length >= 1 ? this.dzList[0].awardLatName : null,
          rewardType: this.dzList.length >= 1 ? this.dzList[0].rewardType : null,
          rewardTypeName: this.dzList.length >= 1 ? this.dzList[0].rewardTypeName : null,
          cashTypeName: this.dzList.length >= 1 ? this.dzList[0].cashTypeName : null,
          cashType: this.dzList.length >= 1 ? this.dzList[0].cashType : null,
          productName: null,
          productCode: null,
          levelBottle: 0,
          levelAmount: 0,
          roundingCoefficient: 0,
          tierType: this.tierType,
        });
      } else {
        if (this.qjList.length === 1) {
          if (!this.qjList[0].awardLat) {
            this.$message.warning('请先选择奖励纬度');
            return;
          }
          if (!this.qjList[0].rewardType) {
            this.$message.warning('请先选择奖励类型');
            return;
          }
          if (!this.qjList[0].cashType) {
            this.$message.warning('请先选择兑付方式');
            return;
          }
        }
        this.qjList.push({
          tableNumMin: 0,
          tableNumMax: 0,
          awardLat: this.qjList.length >= 1 ? this.qjList[0].awardLat : null,
          awardLatName: this.qjList.length >= 1 ? this.qjList[0].awardLatName : null,
          rewardType: this.qjList.length >= 1 ? this.qjList[0].rewardType : null,
          rewardTypeName: this.qjList.length >= 1 ? this.qjList[0].rewardTypeName : null,
          cashTypeName: this.qjList.length >= 1 ? this.qjList[0].cashTypeName : null,
          cashType: this.qjList.length >= 1 ? this.qjList[0].cashType : null,
          productName: null,
          productCode: null,
          rewardNum: 0,
          rewardAmount: 0,
          tierType: this.tierType,
        });
      }
      this.toFather();
    },
    banquetCashTypeChange(val, index) {
      console.log(index);
      console.log(val);
      let res = '';
      if (this.tierType === 1) {
        if (this.dzList[index].rewardType === 'fee' || this.dzList[index].rewardType === 'cash') {
          res = this.banquetCashTypeList.find(
            (item) => item.dictCode === val,
          );
        } else {
          res = this.banquetCashTypeList_1.find(
            (item) => item.dictCode === val,
          );
        }
        this.dzList[index].productName = null;
        this.dzList[index].productCode = null;
        this.dzList[index].levelBottle = 0;
        this.dzList[index].cashTypeName = res.dictValue;
        console.log(this.dzList);
        if (index === 0) {
          this.dzList = [this.dzList[0]];
          this.toFather();
        }
      } else {
        if (this.qjList[index].rewardType === 'fee' || this.qjList[index].rewardType === 'cash') {
          res = this.banquetCashTypeList.find(
            (item) => item.dictCode === val,
          );
        } else {
          res = this.banquetCashTypeList_1.find(
            (item) => item.dictCode === val,
          );
        }
        this.qjList[index].productName = null;
        this.qjList[index].productCode = null;
        this.qjList[index].rewardNum = 0;
        this.qjList[index].cashTypeName = res.dictValue;
        console.log(this.qjList);
        if (index === 0) {
          this.qjList = [this.qjList[0]];
          this.toFather();
        }
      }
    },
    banquetAwardTypeChange(val, index) {
      console.log(index);
      console.log(val);
      if (this.tierType === 1) {
        const res = this.banquetAwardTypeList.find(
          (item) => item.dictCode === val,
        );
        this.dzList[index].rewardTypeName = res.dictValue;
        this.dzList[index].cashType = null;
        this.dzList[index].cashTypeName = null;
        this.dzList[index].productName = null;
        this.dzList[index].productCode = null;
        this.dzList[index].levelBottle = 0;
        this.dzList[index].levelAmount = 0;
        this.dzList[index].roundingCoefficient = 0;

        // 如果是第一行修改rewardType，则保留第一行，删除其余行
        if (index === 0) {
          this.dzList = [this.dzList[0]];
          this.toFather();
        }
      } else {
        const res = this.banquetAwardTypeList.find(
          (item) => item.dictCode === val,
        );
        this.qjList[index].rewardTypeName = res.dictValue;
        this.qjList[index].cashType = null;
        this.qjList[index].cashTypeName = null;
        this.qjList[index].productName = null;
        this.qjList[index].productCode = null;
        this.qjList[index].rewardNum = 0;
        this.qjList[index].rewardAmount = 0;

        // 如果是第一行修改rewardType，则保留第一行，删除其余行
        if (index === 0) {
          this.qjList = [this.qjList[0]];
          this.toFather();
        }
      }

      console.log(this.qjList);
    },
    banquetAwardLatTypeChange(val, index) {
      console.log(index);
      console.log(val);
      if (this.tierType === 1) {
        const res = this.banquetAwardLatTypeList.find(
          (item) => item.dictCode === val,
        );

        this.dzList[index].awardLatName = res.dictValue;
        if (index === 0) {
          this.dzList = [this.dzList[0]];
          this.toFather();
        }
      } else {
        const res = this.banquetAwardLatTypeList.find(
          (item) => item.dictCode === val,
        );

        this.qjList[index].awardLatName = res.dictValue;
        if (index === 0) {
          this.qjList = [this.qjList[0]];
          this.toFather();
        }
      }
    },
    // 打开点击弹窗产品名称
    productNameClick(index) {
      this.rIdex = index;
      console.log('111');
      let params = {};
      if (this.tierType === 1) {
        if (!this.dzList[index].cashType) {
          this.$message.warning('请先选择兑付方式');
          return;
        }
        if (this.dzList[index].cashType === 'thawedCash') {
          params = {
            data: [],
            selectionList: [],
            functionCode: 'jdProList',
            idKey: 'productCode',
            noReset: true,
            paramData: {
              enableStatus: '009',
            },
          };
        }
        if (this.dzList[index].cashType === 'goods') {
          params = {
            data: [],
            selectionList: [],
            functionCode: 'hbProList',
            idKey: 'productCode',
            noReset: true,
            paramData: {
              enableStatus: '009',
            },
          };
        }
      } else {
        if (!this.qjList[index].cashType) {
          this.$message.warning('请先选择兑付方式');
          return;
        }
        if (this.qjList[index].cashType === 'thawedCash') {
          params = {
            data: [],
            selectionList: [],
            functionCode: 'jdProList',
            idKey: 'productCode',
            noReset: true,
            paramData: {
              enableStatus: '009',
            },
          };
        }
        if (this.qjList[index].cashType === 'goods') {
          params = {
            data: [],
            selectionList: [],
            functionCode: 'hbProList',
            idKey: 'productCode',
            noReset: true,
            paramData: {
              enableStatus: '009',
            },
          };
        }
      }

      this.$refs.selectConfig.openSelectModal(params);
    },
    onGetSelect(val) {
      console.log(val);
      if (this.tierType === 1) {
        if (this.dzList[this.rIdex].cashType === 'thawedCash') {
          this.dzList[this.rIdex].productName = val[0].productName;
          this.dzList[this.rIdex].productCode = val[0].productCode;
        }
        if (this.dzList[this.rIdex].cashType === 'goods') {
          this.dzList[this.rIdex].productName = val[0].materialName;
          this.dzList[this.rIdex].productCode = val[0].materialCode;
        }
      } else {
        if (this.qjList[this.rIdex].cashType === 'thawedCash') {
          this.qjList[this.rIdex].productName = val[0].productName;
          this.qjList[this.rIdex].productCode = val[0].productCode;
        }
        if (this.qjList[this.rIdex].cashType === 'goods') {
          this.qjList[this.rIdex].productName = val[0].materialName;
          this.qjList[this.rIdex].productCode = val[0].materialCode;
        }
      }
      this.toFather();
    },
    // 判断去重
    getReset(list1, list2, key) {
      const list = list2;
      if (list1 && list1.length) {
        list1.forEach((v1) => {
          let notRepeat = true;
          const rowData = v1;
          for (const v2 in list2) {
            if (v1[key] === list2[v2][key]) {
              notRepeat = true;
              return false;
            }
          }
          if (notRepeat) {
            list.push(rowData);
          }
          return rowData;
        });
      }
      return list;
    },
  },
};
</script>

<style lang="less" scoped>
.edit-table {
    padding-left: 50px;
    margin-left: 0 !important;

}

.cost-select {
    position: relative;

    /deep/ .el-input__inner {
        padding-right: 30px;
    }

    .clear-icon {
        width: 25px;
        height: 100%;
        position: absolute;
        right: 5px;
        top: 0;
        text-align: center;
        color: #c0c4cc;
        transition: all 0.3s;
        padding-top: 1px;
        display: none;

        .el-icon-circle-close {
            width: 100%;
            font-size: 14px;
            cursor: pointer;
            transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        }
    }

    &:hover {
        .clear-icon {
            display: block;
        }
    }
}
</style>
